import { OrderingInitialState, SetOrderPricingAction } from '@reducers/ordering/types';

export const setOrderPricing = (state: OrderingInitialState, action: SetOrderPricingAction): OrderingInitialState => ({
  ...state,
  pricingState: {
    ...state.pricingState,
    ...action.payload,
  },
});
